import { Component, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface IDocumentUploadPersonOption {
  id: number;
  firstName: string;
  lastName: string;
}

export interface IDocumentUploadDialogData {
  title: string;
  people?: IDocumentUploadPersonOption[];
  allowAssociation?: boolean;
  description?: string | null;
  applicationPersonId?: number | null;
}

export interface IDocumentUploadDialogResult {
  file: File;
  description: string | null;
  applicationPersonId: number | null;
}

@Component({
  selector: 'app-document-upload-dialog',
  templateUrl: './document-upload-dialog.component.html',
  styleUrls: ['./document-upload-dialog.component.scss']
})
export class DocumentUploadDialogComponent {
  public readonly descriptionControl = new FormControl(this.data.description || '');
  public readonly applicationPersonIdControl = new FormControl(this.data.applicationPersonId ?? null);
  public selectedFile: File | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IDocumentUploadDialogData,
    private readonly dialogRef: MatDialogRef<DocumentUploadDialogComponent, IDocumentUploadDialogResult>,
  ) {}

  get people(): IDocumentUploadPersonOption[] {
    return this.data.people || [];
  }

  get allowAssociation(): boolean {
    return this.data.allowAssociation === true;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.selectedFile = input.files?.[0] || null;
    input.value = '';
  }

  clearFile(): void {
    this.selectedFile = null;
  }

  save(): void {
    if (!this.selectedFile) {
      return;
    }

    const description = (this.descriptionControl.value || '').toString().trim();
    this.dialogRef.close({
      file: this.selectedFile,
      description: description.length > 0 ? description : null,
      applicationPersonId: this.allowAssociation
        ? (this.applicationPersonIdControl.value === null || this.applicationPersonIdControl.value === undefined
          ? null
          : Number(this.applicationPersonIdControl.value))
        : null,
    });
  }
}
